import React from 'react';
import { SectionCard } from '../../../../components/Section';
import { IAlpacaOrder } from '../../../../types/alpaca';
import { AlpacaActions } from './AlpacaActions';
import { AlpacaEventsTable } from './AlpacaEventsTable';
import { AlpacaJournal } from './AlpacaJournal';
import { AlpacaTransfer } from './AlpacaTransfer';
import { AlpacaOrder } from './AlpacaOrder';
import { AlpacaMockActions } from './AlpacaMockActions';
import { AlpacaOrderFees } from './AlpacaOrderFees';
import { isLocal } from '../../../../constants/environment';

interface AlpacaDetailsProps {
  order: IAlpacaOrder;
  refresh: () => void;
}

export const AlpacaDetails = React.memo(({ order, refresh }: AlpacaDetailsProps) => (
  <>
    <AlpacaActions order={order} refresh={refresh}>
      {isLocal && <AlpacaMockActions order={order} refresh={refresh} />}
    </AlpacaActions>
    <AlpacaOrder order={order} />
    {order?.alpacaJournal && <AlpacaJournal alpacaJournal={order.alpacaJournal} />}
    {order?.alpacaTransfer && <AlpacaTransfer alpacaTransfer={order.alpacaTransfer} />}
    <SectionCard title="Fees" disablePadding sx={{ mt: '16px', '& .MuiDataGrid-root': { border: 0 } }}>
      <AlpacaOrderFees madkholOrderId={order.orderId} orderId={order.id} />
    </SectionCard>
    <SectionCard title="Events" disablePadding sx={{ mt: '16px', '& .MuiDataGrid-root': { border: 0 } }}>
      <AlpacaEventsTable
        journalId={order.alpacaJournal?.journalId}
        transferId={order.alpacaTransfer?.transferId}
        ntaId={order.alpacaTransfer?.ntaId}
        orderId={order.alpacaOrderId}
      />
    </SectionCard>
  </>
));
